import styled from "styled-components";
import {
    CenteredFlexColumn,
    CenteredFlexRow,
    FlexColumn,
    LeftFlexRow,
} from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { colorsPalettes } from "@similarweb/styles";

export const Container = styled(CenteredFlexColumn)`
    width: 584px;
    height: 520px;
    box-sizing: border-box;
    gap: 32px;
`;

export const TitlesContainer = styled(CenteredFlexColumn)`
    gap: 8px;
`;

export const InviteContainer = styled(FlexColumn)`
    gap: 8px;
`;

export const InnerInviteContainer = styled(LeftFlexRow)`
    gap: 8px;
`;

export const ButtonLoader = styled(PixelPlaceholderLoader)`
    border-radius: 18px;
`;

export const RewardsContainer = styled(CenteredFlexRow)`
    gap: 16px;
`;

export const RewardsCard = styled(CenteredFlexColumn)`
    width: 184px;
    height: 188px;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[50]};
    gap: 13px;
`;

export const RewardsInnerCard = styled(CenteredFlexColumn)`
    width: 168px;
    height: 136px;
    border-radius: 3px;
    background-color: ${colorsPalettes.carbon[0]};
    gap: 4px;
`;

export const RoundedLoader = styled(PixelPlaceholderLoader)`
    border-radius: 6px;
`;

export const ProgressBarContainer = styled(FlexColumn)`
    align-self: flex-start;
    gap: 12px;
`;

export const HowItWorksContainer = styled(LeftFlexRow)`
    align-self: flex-start;
    gap: 4px;
`;
